import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const ERROR_TYPES = {
  NON_MEDICAL_TEXT: {
    icon: '📋',
    title: 'error.types.nonMedical.title',
    action: 'error.types.nonMedical.action'
  },
  FILE_TOO_LARGE: {
    icon: '📁',
    title: 'error.types.fileSize.title',
    action: 'error.types.fileSize.action'
  },
  SYSTEM_ERROR: {
    icon: '⚠️',
    title: 'error.types.system.title',
    action: 'error.types.system.action'
  }
};

export function ErrorDisplay({ error }) {
  const { t } = useTranslation();
  const errorInfo = ERROR_TYPES[error.type] || ERROR_TYPES.SYSTEM_ERROR;

  return (
    <div className="rounded-lg p-6 bg-red-50 border border-red-200">
      <div className="flex items-center space-x-3">
        <span className="text-2xl">{errorInfo.icon}</span>
        <div>
          <h3 className="font-semibold text-red-800">
            {t(errorInfo.title)}
          </h3>
          <p className="mt-1 text-sm text-red-700">
            {error.message}
          </p>
          {error.details && (
            <p className="mt-1 text-sm text-red-600">
              {error.details}
            </p>
          )}
          <p className="mt-3 text-sm font-medium">
            {t(errorInfo.action)}
          </p>
        </div>
      </div>
    </div>
  );
} 